const parseLocalStorageJSON = (key, fallback) => {
  const raw = localStorage.getItem(key);
  if (!raw || raw === "undefined") {
    return fallback;
  }

  try {
    return JSON.parse(raw);
  } catch (error) {
    return fallback;
  }
};

let stateConfig = {
  initial_state: {
    cookiesAccepted: parseLocalStorageJSON("cookiesAccepted", false),
    user_session: parseLocalStorageJSON("user_session", null),
    // Persist cache across refreshes to preserve artwork navigation context
    cache_metas: parseLocalStorageJSON("cache_metas", {}),
    triggeredActions: {},
    guest_settings: {
      claim_cooldown: parseInt(localStorage.getItem("claim_cooldown")) || null
    }
  },
  
  cache: {
    cache_path: 'cache_metas',
    cache_value_default_duration: ['1', 'minutes']
  }
};

export default stateConfig;
